<template>
    <el-dialog title="完结" :visible.sync="completeFlag" :destroy-on-close="true" width="60%" top="70px"
        style="text-align: center">
        <el-form ref="completeForm" :model="addForm" :rules="formRules" label-width="120px">
            <div class="addServicesFormLine">
                <el-form-item label="检测单号：" prop="qcCheckNo">
                    <span>{{ addForm.qcCheckNo }}</span>
                </el-form-item>
                <el-form-item label="质检方式：" prop="checkTypeText">
                    <span>{{ addForm.checkTypeText }}</span>
                </el-form-item>
            </div>
            <div class="addServicesFormLine">
                <el-form-item label="质检数量：" prop="checkQty">
                    <el-input v-model="addForm.checkQty" :disabled="addForm.checkType === 10"
                        placeholder="请输入质检数量"></el-input>
                </el-form-item>
                <el-form-item label="不良数量：" prop="badQty">
                    <el-input v-model="addForm.badQty" placeholder="请输入不良数量"></el-input>
                </el-form-item>
                <el-form-item label="不良原因：" prop="badReason">
                    <el-input v-model="addForm.badReason" placeholder="请输入不良原因"></el-input>
                </el-form-item>
            </div>
            <div class="addServicesFormLine">
                <el-form-item label="检测结果：" prop="checkResult">
                    <el-select v-model="addForm.checkResult" placeholder="请选择检测结果" style="width: 100%;">
                        <el-option v-for="item in checkResultList" :label="item.label" :value="item.value"
                            :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="处理结果：" prop="handleResult">
                    <el-select v-model="addForm.handleResult" placeholder="请选择处理结果" style="width: 100%;">
                        <el-option v-for="item in handleResultList" :label="item.label" :value="item.value"
                            :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="addForm.remark">
                </el-input>
            </el-form-item>
            <el-form-item class="noMarginBottom">
                <el-button type="primary" @click="onSubmit" :loading="addLoading">检测完成</el-button>
                <el-button @click.native="completeFlag = false" :loading="addLoading">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
  
<script>
import {
    CompleteQCCheckInfo,
} from "@/api/QCCheck/index.js";
export default {
    props: ['completeDalogType', 'checkResultList', 'handleResultList'],
    data() {
        return {
            addForm: {},
            completeFlag: false,
            addLoading: false,
            formRules: {
                checkQty: [{ required: true, message: "请输入质检数量", trigger: "blur" }],
                badQty: [{ required: true, message: "请输入不良数量", trigger: "blur" }],
                badReason: [{ required: true, message: "请输入不良原因", trigger: "blur" }],
                checkResult: [{ required: true, message: "请选择检测结果", trigger: "blur" }],
                handleResult: [{ required: true, message: "请选择处理结果", trigger: "blur" }],
            },
        };
    },
    methods: {
        showDalog(data) {
            // 设置增值服务类型下拉
            if (this.completeDalogType == 'complete') {
                let { qcCheckInfoID, qcCheckNo, remark, checkType, checkTypeText, quantity } = data
                this.addForm = { qcCheckInfoID, qcCheckNo, checkQty: quantity, checkType, checkTypeText, remark }
            }

            this.completeFlag = true
        },
        onSubmit(status) {
            this.$refs.completeForm.validate((valid) => {
                if (valid) {
                    let { qcCheckInfoID, checkQty, badQty, badReason, checkResult, handleResult, remark } = this.addForm
                    this.addLoading = true;
                    let params = {
                        qcCheckInfoID, checkQty, badQty, badReason, checkResult, handleResult, remark
                    }
                    CompleteQCCheckInfo(params).then((res) => {
                        this.addLoading = false;
                        if (res.data.success) {
                            this.$refs["completeForm"].resetFields();
                            this.$message({
                                message: res.data.msg || "操作成功",
                                type: "success",
                            });
                            this.completeFlag = false;
                            this.$emit("searchTable", "");
                        } else {
                            this.$message({
                                message: res.data.msg || "操作失败",
                                type: "error",
                            });
                        }
                    })
                }
            });
        },
    },
    mounted() {

    },
};
</script>

<style lang="less" scoped>
.addServicesFormLine {
    display: flex;
    text-align: left;
    white-space: nowrap;

    >div {
        width: 33.333%;
    }


    .el-date-editor.el-input {
        width: 100%;
    }
}
.noMarginBottom {
    margin-bottom: 0 !important;
}
</style>
  
  